import PatientAccountRecord from './PatientAccountRecord';

export default PatientAccountRecord;
